import { stat } from "fs"
export default {
    // namespace:true,
    state:{
        arr:[],
        gettroubledetail:{
            a:111
        }
    },
    getters: {
        troublearr(state){
          return state.arr
        },
        gettroubledetail(state){
            return state.gettroubledetail
        }
    },
    mutations:{
        settroublearr(state,playload){
            state.arr=playload
        },
        changetroubledetail(state,playload){
            state.gettroubledetail=playload
        }
    },
    actions:{
    }
}